import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

// project import
import { connect } from 'react-redux';
import { useResiPermissions } from '../../hooks/useResiPermissions';

// ==============================|| RESI GUARD ||============================== //

const GuestGuard = ({ children, userData, authUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isGuest } = useResiPermissions();
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        if (!authUser) {
            navigate('/login', { replace: true });
        }
    }, [authUser, navigate]);

    useEffect(() => {
        if (userData) {
            setIsChecking(false);
        }
    }, [userData]);

    if (!authUser || isChecking) {
        return null;
    }

    if (userData?.photo_id === null) {
        if (location.pathname !== '/upload-identification') {
            return <Navigate to="/upload-identification" state={{ from: location }} />;
        }
        return children;
    }

    if (!isGuest) {
        return <Navigate to="/maintenance/404" state={{ from: location }} />;
    }

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node,
    userData: PropTypes.object,
    authUser: PropTypes.object
};

const mapStateToProps = ({ user, auth }) => {
    const { authUser } = auth;
    const { userData } = user;

    return { userData, authUser };
};

export default connect(mapStateToProps, null)(GuestGuard);
